import {useEffect} from 'react';
import {RoleNames} from '../../../shared/constants';
import SummarizeDataGrid from './data-grid/SummarizeDataGrid';
import SummarizeHeader from './header/SummarizeHeader';
import {RootState} from '../../../redux/store';
import {useDispatch, useSelector} from 'react-redux';
import {
  subscribeToGroup,
  unsubscribeFromGroup,
} from '../../../redux/middleware/signalrMiddleware';

const ViewAISummarize = () => {
  const loginUserData = useSelector(
    (state: RootState) => state.authenticatedUser.user
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (loginUserData?.roleName === RoleNames.ReviewManager) {
      const groupSecurityGroup = `${loginUserData?.entityId}_${loginUserData?.projectId}_${loginUserData?.securityGroupId}`;
      dispatch(subscribeToGroup(groupSecurityGroup));

      return () => {
        dispatch(unsubscribeFromGroup(groupSecurityGroup));
      };
    }
  }, [loginUserData]);
  return (
    <>
      <SummarizeHeader />
      <SummarizeDataGrid />
    </>
  );
};

export default ViewAISummarize;
